// extracted by mini-css-extract-plugin
export var phone = "_58-0";
export var phoneDragging = "_58-1";